import React, { useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const AgeRanges = {
  EighteenToTwentyFive: _TL_('18-24'),
  TwentyFiveToThirtyFive: _TL_('25-34'),
  ThirtyFiveToFifty: _TL_('35-49'),
  FiftyToSixtyFive: _TL_('50-64'),
  SixtyFiveAndAbove: _TL_('65+'),
  Unknown: _TL_('Unknown'),
  // LinkedIn specific
  ThirtyFiveToFiftyFive: _TL_('35-54'),
  FiftyFiveAndAbove: _TL_('55+'),
};

const sortAgeRanges = ageRanges => _.sortBy(ageRanges, ageRange => AgeRanges[ageRange]);

export const formatAgeRange = (ageRange, i18n) => (AgeRanges[ageRange] ? i18n.getString(AgeRanges[ageRange]) : ageRange);

export const formatAgeRanges = (ageRanges, i18n) => _.chain(sortAgeRanges(ageRanges))
  .map(ageRange => formatAgeRange(ageRange, i18n))
  .join(i18n.getString(_TL_(', ')))
  .value();

export const AgeRangeTargeting = ({ ageRanges }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Age') }}>
      <Text>{formatAgeRanges(ageRanges, i18n)}</Text>
    </PropertyRow>
  );
};

AgeRangeTargeting.propTypes = {
  ageRanges: PropTypes.arrayOf(PropTypes.string),
};

AgeRangeTargeting.defaultProps = {
  ageRanges: [],
};
